import React from "react"
import propTypes from "prop-types"

const Item = ({ children }) => {
  return <div className="info-card_item">{children}</div>
}

Item.propTypes = {
  children: propTypes.oneOfType([propTypes.node, propTypes.string]).isRequired
}

export default Item
